import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import { IManualDeliverableStatus } from '@interfaces/campaign-analytics-api.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ManualDeliverableStatusService {
  private readonly http = inject(HttpClient);

  public getManualDeliverableStatuses(params?: HttpParams): Observable<IApiResponse<IManualDeliverableStatus[]>> {
    return this.http.get<IApiResponse<IManualDeliverableStatus[]>>(`/manual-deliverable-status`, { params });
  }

  public getManualDeliverableStatusesExport(
    exportId: string,
    params?: HttpParams,
  ): Observable<IApiResponse<IManualDeliverableStatus[]>> {
    return this.http.get<IApiResponse<IManualDeliverableStatus[]>>(`/manual-deliverable-status/export/${exportId}`, {
      params,
    });
  }

  public getManualDeliverableStatusesBriefing(
    briefingId: string,
    params?: HttpParams,
  ): Observable<IApiResponse<IManualDeliverableStatus[]>> {
    return this.http.get<IApiResponse<IManualDeliverableStatus[]>>(
      `/manual-deliverable-status/briefing/creator/${briefingId}`,
      { params },
    );
  }

  public createManualDeliverableStatus(data: IManualDeliverableStatus): Observable<IManualDeliverableStatus> {
    return this.http.post<IManualDeliverableStatus>(`/manual-deliverable-status`, data);
  }

  public updateManualDeliverableStatus(
    id: string,
    data: IManualDeliverableStatus,
  ): Observable<IManualDeliverableStatus> {
    return this.http.put<IManualDeliverableStatus>(`/manual-deliverable-status/${id}`, data);
  }
}
